import React from "react";
import outline from "../../assets/icons/contact_dna-01-01.svg";
import instagram from "../../assets/icons/instagram (2).png";
import facebook from "../../assets/icons/facebook (2).png";
import linkedin from "../../assets/icons/linkedin-sign.png";
import youtube from "../../assets/icons/play.png";
import { Mail, MapPin, Phone, Send } from "lucide-react";

const ContactJoin = () => {
  const socialMedial = [
    {
      icon: instagram,
      url: "https://www.instagram.com/dr.hemanthmakineni/",
    },

    {
      icon: facebook,
      url: "https://www.facebook.com/drhemanthmakineni/",
    },

    {
      icon: linkedin,
      url: "https://www.linkedin.com/in/hemanth-makineni-3b299752/",
    },

    {
      icon: youtube,
      url: "https://youtube.com",
    },
  ];
  return (
    <div className=" xl:py-28 lg:py-20 md:py-14 py-10 relative">
      <div className="bottom-0 w-full h-full left-0 absolute">
        <img src={outline} alt="outline" className="w-full h-full" />
      </div>
      <div data-aos="fade-up" className="xl:w-[1240px] w-11/12 mx-auto z-10 relative">
        <div className="grid md:grid-cols-2 grid-cols-1 lg:gap-24 gap-5 ">
          <div>
            <h2 className="xl:text-5xl lg:text-4xl md:text-3xl flex flex-col lg:gap-6 gap-2 text-xl font-medium mt-2 text-matcha">
              Connect with{" "}
              <span className="font-semibold">Dr. Hemanth Makineni</span>
            </h2>
          </div>
          <div className="flex justify-between flex-col">
            <p className=" text-base leading-6  text-matcha">
              I’d love to hear from you! Whether you have questions, feedback,
              or just want to say hello, feel free to reach out.
            </p>
            <p className="text-base flex flex-row gap-3 text-matcha font-normal py-3 mt-3 md:mt-0">
              {socialMedial.map((item, index) => (
                <a
                  key={crypto.randomUUID()}
                  className="bg-matcha flex hover:bg-matcha  border-dashed border border-pistache transition justify-center items-center p-2 rounded-full"
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  <img src={item.icon} className=" w-5 " alt="" />
                </a>
              ))}
            </p>{" "}
          </div>
        </div>
        <div className="grid lg:grid-cols-3 grid-cols-1 lg:mt-16 md:mt-10 mt-6   lg:gap-10 gap-5 ">
          <div className="p-5 flex flex-col gap-3 bg-almond rounded-xl">
            <div className="w-14 h-14 flex justify-center items-center bg-matcha text-almond rounded-full">
              <Phone />
            </div>
            <h3 className="md:text-2xl text-xl font-bold text-matcha ">
              I am just a call away
            </h3>
            <div>
              <a
                href="tel:+917894504321"
                className="md:text-lg font-bold hover:border-matcha duration-300 transition hover:border-b-2 text-matcha"
              >
                +91 78945 04321
              </a>
            </div>
          </div>
          <div className="p-5 flex flex-col gap-3 bg-almond rounded-xl">
            <div className="w-14 h-14 flex justify-center items-center bg-matcha text-almond rounded-full">
              <Mail />
            </div>
            <h3 className="md:text-2xl text-xl font-bold text-matcha ">
              Email me anytime
            </h3>
            <div>
              <a
                href="mailto:drhemanth@gmail.com"
                className="md:text-lg font-bold hover:border-matcha duration-300 transition hover:border-b-2 text-matcha"
              >
                drhemanth@gmail.com
              </a>
            </div>
          </div>
          <div className="p-5 flex flex-col gap-1 bg-almond rounded-xl">
            <div className="w-14 h-14 flex mt-1 justify-center items-center bg-matcha text-vanilla rounded-full">
              <MapPin />
            </div>
            <h3 className="md:text-2xl text-xl font-bold text-matcha ">
              Where can you find me?
            </h3>
            <div>
              <a
                href="https://maps.app.goo.gl/cZZ5yX9AdXHvqLGYA"
                target="_blank"
                rel="noreferrer noopener"
                className="md:text-lg font-bold hover:border-matcha duration-300 transition hover:border-b-2 text-matcha"
              >
                Arka Hospital & Research Institute, Guntur
              </a>
            </div>
          </div>
        </div>
        <div className="grid lg:grid-cols-2 grid-cols-1 lg:mt-16 md:mt-10 mt-6  lg:gap-16 gap-5">
          <div className="">
            <h3 className="text-xl font-bold text-matcha ">Send Message</h3>
            <form
              action=""
              className="flex  flex-col justify-between"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="mt-4 grid sm:grid-cols-2 grid-cols-1 sm:gap-4 gap-2">
                <div>
                  <label className="text-base font-bold ps-1 text-matcha">
                    Full Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Your Name"
                    className="w-full text-base text-matcha font-normal placeholder:text-matcha rounded-lg py-2 px-3 mt-1 bg-transparent outline-none border border-matcha  focus:border-[#B87333] "
                  />
                </div>
                <div>
                  <label
                    htmlFor="countries"
                    className="text-base font-bold ps-1 text-matcha"
                  >
                    Gender
                  </label>
                  <select
                    id="countries"
                    className="w-full text-base text-matcha font-normal placeholder:text-matcha rounded-lg py-2 px-3 mt-1 bg-transparent outline-none border border-matcha  focus:border-[#B87333] "
                  >
                    <option value="choose-option">Choose Option</option>
                    <option value="female">Female</option>
                    <option value="male">Male</option>
                  </select>
                </div>
              </div>
              <div className="mt-2 grid sm:grid-cols-2 grid-cols-1 sm:gap-4 gap-2">
                {" "}
                <div>
                  <label className="text-base font-bold ps-1 text-matcha">
                    Email
                  </label>
                  <input
                    type="email"
                    placeholder="your@gmail.com"
                    className="w-full text-base text-matcha font-normal placeholder:text-matcha rounded-lg py-2 px-3 mt-1 bg-transparent outline-none border border-matcha  focus:border-[#B87333] "
                  />
                </div>
                <div>
                  <label className="text-base font-bold ps-1 text-matcha">
                    Phone
                  </label>
                  <input
                    placeholder="+917894561230"
                    className="w-full text-base text-matcha font-normal placeholder:text-matcha rounded-lg py-2 px-3 mt-1 bg-transparent outline-none border border-matcha  focus:border-[#B87333] "
                  />
                </div>
              </div>
              <div className="mt-2 grid sm:grid-cols-2 grid-cols-1 sm:gap-4 gap-2">
                <div>
                  <label className="text-base font-bold ps-1 text-matcha">
                    Time
                  </label>
                  <input
                    type="time"
                    placeholder="your@gmail.com"
                    className="w-full text-base text-matcha font-normal placeholder:text-matcha rounded-lg py-2 px-3 mt-1 bg-transparent outline-none border border-matcha  focus:border-[#B87333] "
                  />
                </div>
                <div>
                  <label className="text-base font-bold ps-1 text-matcha">
                    Date
                  </label>
                  <input
                    type="date"
                    placeholder="+917894561230"
                    className="w-full text-base text-matcha font-normal placeholder:text-matcha rounded-lg py-2 px-3 mt-1 bg-transparent outline-none border border-matcha  focus:border-[#B87333] "
                  />
                </div>
              </div>
              <div className="my-2 ">
                <div>
                  <label className="text-base font-bold ps-1 text-matcha">
                    Additional Message
                  </label>
                  <textarea
                    placeholder="Additional information"
                    rows={4}
                    className="w-full text-base resize-none text-matcha font-normal placeholder:text-matcha rounded-lg py-2 px-3 mt-1 bg-transparent outline-none border border-matcha  focus:border-[#B87333] "
                  />
                </div>
              </div>
              <button className="bg-matcha  py-3 sm:w-40 w-full text-white text-base font-semibold border border-matcha  flex flex-row items-center justify-center gap-4 rounded-lg hover:bg-transparent hover:text-matcha duration-200 transition">
                Send <Send size={20} strokeWidth={1} />
              </button>
            </form>
          </div>
          <div className="rounded-xl overflow-hidden">
            <iframe
              title="Arka Hospitals"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4542.0806266390855!2d80.47095809999999!3d16.3173951!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a4a0b95d01fe695%3A0x9d952aaef308a215!2sArka%20Hospital%20%26%20Research%20Institute%20-%20Best%20Cancer%20Treatment%20Hospital%20in%20Guntur!5e1!3m2!1sen!2sin!4v1778660787715!5m2!1sen!2sin"
              className="w-full lg:h-full h-72"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactJoin;
